import {SystemBanner} from '@dropbox/dig-components/system_banner';
import {Text} from '@dropbox/dig-components/typography';
import {atoms, Box, Stack} from '@dropbox/dig-foundations';
import DropboxOSIconDark from 'assets/DropboxOSIconDarkMobile.svg';
import DropboxOSIcon from 'assets/DropboxOSIconMobile.svg';
import {derivedThemeAtom} from 'atoms/layout';
import {Link} from 'components/DSYS/Link';
import {Title} from 'components/DSYS/Title';
import {useAtomValue} from 'jotai';
import {ReactNode} from 'react';

export const Path = ({path}: {path: string}) => (
  <Text
    color="subtle"
    style={{fontFamily: 'monospace'}}
    size="small"
    className={atoms({marginLeft: '8'})}
  >
    <Link
      to={`https://github.com/dropbox-internal/dropbox-pulse-server/blob/main/web/${path}`}
      monochromatic
    >
      {path}
    </Link>
  </Text>
);

export const Note = ({
  type,
  title,
  path,
  info,
  children,
}: {
  type: string;
  info: ReactNode;
  title?: string;
  path?: string;
  children?: ReactNode;
}) => {
  const isDarkMode = useAtomValue(derivedThemeAtom) === 'dark';
  return (
    <Box
      borderRadius="Large"
      padding="12"
      borderWidth="1"
      borderStyle="Solid"
      borderColor="transparent"
      boxShadow="Raised"
    >
      <Stack>
        <Box style={{top: 100, zIndex: 3}} position="sticky" backgroundColor="Background Base">
          <Title
            id={type.toLowerCase().replace(/[/ ]/g, '-')}
            size="small"
            withAccessoryStart={
              path && <img src={isDarkMode ? DropboxOSIconDark : DropboxOSIcon} height="26px" />
            }
            withAccessoryEnd={path && <Path path={path} />}
            className={atoms({marginBottom: '12'})}
          >
            {type}
          </Title>
        </Box>

        <SystemBanner tone="attention" className={atoms({padding: '8', marginBottom: '12'})}>
          <Text style={{maxWidth: 600}}>{info}</Text>
        </SystemBanner>

        {children && (
          <Box
            backgroundColor="Background Subtle"
            borderRadius="Large"
            padding="12"
            overflowX="auto"
          >
            {children}
          </Box>
        )}
        {title && (
          <Text size="small">
            <pre
              style={{fontFamily: 'monospace'}}
              className={atoms({
                padding: '8',
                paddingLeft: '12',
                overflowX: 'auto',
                marginTop: '8',
                borderRadius: 'Large',
                color: 'Text Subtle',
                backgroundColor: 'Background Subtle',
              })}
            >
              {title}
            </pre>
          </Text>
        )}
      </Stack>
    </Box>
  );
};
